module.exports = __webpack_public_path__ + "static/media/dmi.642f0961.png";